// Full-document render of the store-locator city index inside PageSkeleton.
// Simple copy is ttag `t`; the title (inline <br>/<a> markup) arrives
// pre-localized as `title_html` so its exact msgid keeps its fr_CA
// translation.
import React from "react";
import { t } from "ttag";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

// Mutable reactivated props (not Immutable<>): composes PageSkeleton.
type IProps = templates.LocationsByCityTemplate;

export const Template = (props: IProps): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="store-locator">
                <div className="store-locator__hero l-full-width">
                    <h1 className="store-locator__hero-title">
                        {t`Find a Retailer`}
                    </h1>
                </div>

                <div className="l-capped-width">
                    <nav
                        className="breadcrumb"
                        role="region"
                        aria-label={t`breadcrumbs`}
                    >
                        <ul className="breadcrumb__list">
                            <li className="breadcrumb__list-item">
                                <a href={props.home_url}>{t`Home`}</a>
                            </li>
                            <li className="breadcrumb__list-item">
                                <a href={props.store_locator_url}>
                                    {t`Store Locator`}
                                </a>
                            </li>
                            <li className="breadcrumb__list-item">
                                <a href={props.find_retailer_url}>
                                    {t`Find a Retailer`}
                                </a>
                            </li>
                            <li
                                className="breadcrumb__list-item"
                                aria-current="page"
                            >
                                <a href={props.state_url}>{props.state_name}</a>
                            </li>
                        </ul>
                    </nav>

                    <div className="store-locator__header">
                        <h2
                            className="store-locator__title"
                            dangerouslySetInnerHTML={{
                                __html: props.title_html,
                            }}
                        />
                        <p className="store-locator__description">
                            {t`Browse state-by-state, city-by-city, for the Tempur-Pedic retailer of your choice.`}
                        </p>
                    </div>

                    <div className="store-locator__list">
                        <p className="store-locator__list-label">
                            {t`Select a City:`}
                        </p>
                        <div className="store-locator__list-container">
                            {props.cities.map((city) => (
                                <span
                                    key={city.url}
                                    className="store-locator__list-item"
                                >
                                    <a
                                        className="store-locator__list-link"
                                        href={city.url}
                                    >
                                        {city.city}{" "}
                                        <span className="store-locator__list-link__count">
                                            ({city.store_count})
                                        </span>
                                    </a>
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </PageSkeleton>
    );
};
